/** Structured marketplace cancel / decline reason codes → display labels. */
const CANCEL_REASON_LABELS = {
  CHANGED_MIND: "Changed mind",
  ORDERED_BY_MISTAKE: "Ordered by mistake",
  TOO_LONG_WAIT: "Taking too long",
  WRONG_ITEMS: "Wrong items / details",
  OTHER: "Other",
  OUT_OF_STOCK: "Out of stock",
  RESTAURANT_CLOSED: "Restaurant closed",
  CANNOT_FULFILL: "Cannot fulfill",
  CUSTOMER_REQUEST: "Customer requested",
  AUTO_ACCEPT_TIMEOUT: "Auto-accept timeout",
  TOO_FAR: "Too far",
  VEHICLE_ISSUE: "Vehicle issue",
  UNSAFE_AREA: "Unsafe area",
  UNAVAILABLE: "Unavailable",
  CustomerCancelled: "Customer cancelled",
  RestaurantCancelled: "Restaurant cancelled",
  RestaurantRejected: "Restaurant rejected",
  Timeout: "Timeout",
  LegacyText: "Legacy (free text)",
  Unknown: "Unknown",
};

export function labelForCancelReasonCode(code) {
  const trimmed = (code ?? "").toString().trim();
  if (!trimmed) return "";
  return CANCEL_REASON_LABELS[trimmed] || trimmed;
}

export function labelForCancelledByType(type) {
  const t = (type ?? "").toString().trim();
  if (!t || t.toLowerCase() === "unknown") return "Unattributed";
  return t;
}
